import { useRoutedNavigation } from './useRoutedNavigation';

/**
 * Abre o destino de um menu/item de menu: URL externa em nova aba e rota interna (ex.: "pagina/{slug}")
 * como caminho absoluto, preservando o prefixo /:state/:city.
 * newTab também abre rotas internas em nova aba (opção "Abrir em nova aba" da home customizada).
 */
export const useMenuLinkNavigation = () => {
  const { navigateTo, buildPath } = useRoutedNavigation();

  return (url?: string, newTab?: boolean) => {
    if (!url) return;

    const isAbsolute = /^https?:\/\//i.test(url);
    // Link externo cadastrado sem protocolo (ex.: "www.site.com.br"); slugs e rotas do portal nunca têm ponto
    const isBareDomain = !isAbsolute && /^[\w-]+(\.[\w-]+)+(\/|$)/i.test(url);

    if (isBareDomain) {
      window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
    } else if (isAbsolute) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      const path = url.startsWith('/') ? url : `/${url}`;
      if (newTab) {
        window.open(buildPath(path), '_blank', 'noopener,noreferrer');
      } else {
        navigateTo(path);
      }
    }
  };
};
